import React from 'react'
import { StatusCellStyles } from './Style'
import { Chip } from 'components/Form'
import { statusItems } from 'keys/assesmentDefStatuses'

const StatusCell = (props) => {
    const { cell } = props
    const status = cell.getValue()

    const statusItem = statusItems[status]
    const { color, label } = statusItem || {}

    return (
        <StatusCellStyles>
            <Chip color={color}>
                {label}
            </Chip>
        </StatusCellStyles>
    )
}

export default StatusCell